const T = require("react").PropTypes;

const UUID = require("node-uuid");

const AnswerSelection = {
    PropType: T.shape({
        GUID: T.string.isRequired,
        AdditionalComment: T.string,
        SelectionScoreValue: T.number,
        SelectionText: T.oneOfType([
            T.string,
            T.arrayOf(T.string)])
    }),
    New(selectionText, comment, guid, score) {
        return {
            GUID: guid || UUID.v1(),
            SelectionText: selectionText,
            AdditionalComment: comment || "",
            SelectionScoreValue: score || 0
        }
    },
    NewForCauditList(selectionText, comment, guid, score) {
        let result = AnswerSelection.New(selectionText, comment, guid, score);

        // HasDiscrepancies could be true, false, or undefined.
        if (selectionText.length > 1) {
            if(selectionText[selectionText.length - 1].length > 0) {
                result.HasDiscrepancies = true;
            }
            // If the first entry has text, but the last entry does not,
            // then this is definitively false.
            else if (selectionText[0].length > 0){
                result.HasDiscrepancies = false;
            }
            else {
                result.HasDiscrepancies = null;
            }
        }

        return result;
    }
};

module.exports = AnswerSelection;


// WEBPACK FOOTER //
// ./src/types/AnswerSelection.js